import { PartnersPageMode } from 'types/state';
import { useRouteMatchStrict } from 'hooks/useRouteMatchStrict';
import { routes } from 'utils/routes';

export const usePartnersPageMode = (): PartnersPageMode => {
  const { path: actualPath } = useRouteMatchStrict();

  switch (actualPath) {
    case routes.partnersPattern():
      return 'ACTUAL_PARTNERS';
    default:
      throw new TypeError();
  }
};
